import React, { Fragment } from 'react';
import {Card} from "antd";
import {compose} from "redux";
import AnnotationForm from './AnnotationForm';
import { MARGIN_MD } from '../../../../../styles/constants';
import DefaultAnnotationForm from './DefaultAnnotationForm';

const LayoutAnnotationsCard = ({
    title,
    firstAnnotations,
    defaultAnnotation,
    lastAnnotations,
    onChange,
  }) =>
    <Card
      type="inner"
      title={title}
      style={{marginBottom: MARGIN_MD}}
    >
      <Fragment>
        {
          (firstAnnotations || []).map(({label, annotation, annotationName}, key) => 
            <AnnotationForm 
              key={key}
              label={label}
              value={annotation}
              name={annotationName}
              onChange={onChange}
            />
          )
        }
        <DefaultAnnotationForm 
          label={defaultAnnotation.label}
          value={defaultAnnotation.annotation}
          name={defaultAnnotation.annotationName}
          onChange={onChange}
        />
        {
          (lastAnnotations || []).map(({label, annotation, annotationName}, key) => 
            <AnnotationForm 
              key={key}
              label={label}
              value={annotation}
              name={annotationName}
              onChange={onChange}
            />
          )
        }
      </Fragment>
    </Card>

  export default compose(
  )(LayoutAnnotationsCard);
